import { render, staticRenderFns } from "./Metarich.vue?vue&type=template&id=fa21e11a&scoped=true&"
import script from "./Metarich.vue?vue&type=script&lang=js&"
export * from "./Metarich.vue?vue&type=script&lang=js&"
import style0 from "./Metarich.vue?vue&type=style&index=0&id=fa21e11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa21e11a",
  null
  
)

export default component.exports